import { createSelector } from "reselect";
import { momentLocalizationMap } from "~/utils/localization";
import { getLoggedUser, makeGetLoggedUserLanguageIdSelector } from "./selector.users.jsx";

export const getAllLanguages = createSelector(
  (state) => state.languages,
  (languages) => languages
);

export const getLanguagesArray = createSelector(getAllLanguages, (languages) => Object.values(languages));
export const getLanguageById = createSelector(
  getAllLanguages,
  (state, id) => id,
  (languages, id) => languages[id]
);

// ISO 639-1: two-letter codes, one per language for ISO 639 macrolanguage
export const getLanguageISO639_1 = createSelector(
  getLanguageById,
  (language) => language && language.locale.substr(0, 2)
);

export const getDecimalAndThousandSeparators = createSelector(
  getAllLanguages,
  makeGetLoggedUserLanguageIdSelector(),
  (languages, languageId) => {
    const language = languages[languageId];
    if (language) {
      return {
        decimal_separator: language.decimal_separator || `.`,
        thousand_separator: language.thousand_separator || `,`,
      };
    }
    return {
      decimal_separator: `.`,
      thousand_separator: `,`,
    };
  }
);

export const getDefaultLanguage = createSelector(getLanguagesArray, (languages) => {
  return languages.find((lang) => lang.is_default);
});

export const getMomentLocaleCode = createSelector(getLoggedUser, getAllLanguages, (user, languages) => {
  if (user) {
    const language = languages[user.language_id];
    if (language) {
      let [locale] = language.locale.split(".");
      locale = locale.replace("_", "-");

      let result = momentLocalizationMap[locale];
      if (result) {
        return result;
      }
    }
  }
  return "en";
});
